// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"54fe650e","68":"5ac0ecf2","71":"6a1867ed","587":"d526dd33","781":"8f8179f9"}[chunkId] + ".css";
};